module.exports = __webpack_public_path__ + "static/media/ninos.9e8fecc7.svg";